import { render, staticRenderFns } from "./CollegiateNotAllowToPrescribeMsg.vue?vue&type=template&id=3af64586&scoped=true"
import script from "./CollegiateNotAllowToPrescribeMsg.vue?vue&type=script&lang=js"
export * from "./CollegiateNotAllowToPrescribeMsg.vue?vue&type=script&lang=js"
import style0 from "./CollegiateNotAllowToPrescribeMsg.vue?vue&type=style&index=0&id=3af64586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af64586",
  null
  
)

export default component.exports